import { useEffect, useState, type ReactNode } from "react";
import { useLocation } from "react-router";
import {
  buildDocumentTitle,
  sectionTitleForLocation,
} from "@/lib/documentTitle/documentTitle";
import { DocumentTitleDetailContext } from "@/lib/documentTitle/useDocumentTitleDetail";
import { useWorkspaceTabsOptional } from "@/modules/workspace/workspaceTabsContext";

/**
 * Keeps the browser tab title on "<what is open> · <section> — Sigma".
 * The section comes from the route; pages showing one record set the
 * detail with useDocumentTitleDetail.
 */
export const DocumentTitleProvider = ({ children }: { children: ReactNode }) => {
  const [detail, setDetail] = useState<string | null>(null);
  const location = useLocation();
  const workspace = useWorkspaceTabsOptional();
  const section = sectionTitleForLocation(location.pathname, location.search);

  useEffect(() => {
    document.title = buildDocumentTitle(detail, section);
    workspace?.rememberTitle(detail?.trim() || section || "Page");
  }, [detail, section, workspace]);

  return (
    <DocumentTitleDetailContext.Provider value={setDetail}>
      {children}
    </DocumentTitleDetailContext.Provider>
  );
};
